// Copyright 2026 L3montree GmbH and the DevGuard Contributors.
// SPDX-License-Identifier: 	AGPL-3.0-or-later

"use client";

import useHashScroll from "@/hooks/useHashScroll";

export default function HashScroll() {
  useHashScroll();
  return null;
}
